import type { TerminalDto } from "src/app/features/Terminal/types/TerminalDto";
import type { TerminalEntity } from "src/app/features/Terminal/types/TerminalEntity";
import { flattenNestedObject } from "../../../../../core/utils/utilFunctions";

export const TerminalDtoToEntity = ({
    dynamicProperties,
    merchantReferenceNumber1,
    merchantReferenceNumber2,
    tipHandling,
    surchargeAmount,
    taxAmount,
    ...rest
}: Readonly<TerminalDto>): TerminalEntity => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "CHECKBOX" ? propValue.value === "true" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern || "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    // Flatten nested DTO fields into dotted keys on the Entity
    const flattenedMerchantRef1 = flattenNestedObject(merchantReferenceNumber1, "merchantReferenceNumber1");
    const flattenedMerchantRef2 = flattenNestedObject(merchantReferenceNumber2, "merchantReferenceNumber2");
    const flattenedTipHandling = flattenNestedObject(tipHandling, "tipHandling");
    const flattenedSurchargeAmount = flattenNestedObject(surchargeAmount, "surchargeAmount");
    const flattenedTaxAmount = flattenNestedObject(taxAmount, "taxAmount");

    return {
        ...rest,
        ...flattenedMerchantRef1,
        ...flattenedMerchantRef2,
        ...flattenedTipHandling,
        ...flattenedSurchargeAmount,
        ...flattenedTaxAmount,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    } as TerminalEntity;
};
